/**
 * Feature Support Checks
 *
 * @module
 */

/**
 * @return {boolean}
 */
export function mediaQuery() {
    return 'MediaQueryList' in window && 'addEventListener' in MediaQueryList.prototype;
}
